
import Vue from "vue";
import Component from "vue-class-component";

@Component<Block>({})
export default class Block extends Vue {}
